import React, {Component} from 'react';
import { withRouter } from "react-router";
import css from './Repstats.module.scss';
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import axios from "axios";
import setFallbackAvatar from "../../utils/setFallbackAvatar";
import SearchList from "../../components/SearchList/SearchList";
import moment from 'moment';


/**
 * @class
 */
const Repstats = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();

    repId = this.props.match.params.id;

    postRequestQuarterSales = {
        "fields": {
            "Id": 1,
            "Total_Sold_Deals_This_Quarter__c": 1,
            "Name": 1,
            "FirstName": 1,
            "LastName": 1
        },
        "where": {
            "Active__c": true,
            "Job_Department__c": "Sales"
        },
        "orderBy": {
            "Total_Sold_Deals_This_Quarter__c": 1
        }
    };

    postRequestContact = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "toLabel(Job_Title__c)",
            "Account_Name__c",
            "Available_Start_Date__c",
            "Total_Sold_Deals__c",
            "Total_Pending_Sales__c",
            "Total_Sold_Deals_This_Quarter__c",
            "Leads_Best_Record_Day__c",
            "Pending_Sales_Best_Record_Day__c",
            "Sales_Best_Record_Day__c",
            "Leads_Best_Record_Week__c",
            "Pending_Sales_Best_Record_Week__c",
            "Sales_Best_Record_Week__c",
            "Leads_Best_Record_Month__c",
            "Pending_Sales_Best_Record_Month__c",
            "Sales_Best_Record_Month__c",
            "Total_Leads__c"
        ],
        "where": {
            "Id": this.props.match.params.id
        }
    };

    // ---------- state: ----------
    state = {
        isFlipped: false, // whether card is flipped or not

        salesRep: {
            rank: null,
            conversionRate: 0,
            salesRepsQuarterSales: []
        },

        best: {
            day:     {},
            week:    {},
            month:   {},
            allTime: {}
        }
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        window.scrollTo(0, 0);

        axios.post(
            '/sf/contact/findNo',
            this.postRequestContact,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];

                const conversionRate = Math.round((data.Total_Sold_Deals__c / data.Total_Pending_Sales__c) * 100);

                this.setState({
                    salesRep: {
                        id:                 this.repId,
                        name:               data.Name,
                        jobTitle:           data.Job_Title__c,
                        accountName:        data.Account_Name__c,
                        startDate:          data.Available_Start_Date__c ? moment(data.Available_Start_Date__c).format('MM/DD/YYYY') : '',
                        conversionRate:     conversionRate,
                        salesThisQuarter:   data.Total_Sold_Deals_This_Quarter__c
                    },

                    best: {
                        day: {
                            leads:          data.Leads_Best_Record_Day__c,
                            pendingSales:   data.Pending_Sales_Best_Record_Day__c,
                            sales:          data.Sales_Best_Record_Day__c
                        },
                        week: {
                            leads:          data.Leads_Best_Record_Week__c,
                            pendingSales:   data.Pending_Sales_Best_Record_Week__c,
                            sales:          data.Sales_Best_Record_Week__c
                        },
                        month: {
                            leads:          data.Leads_Best_Record_Month__c,
                            pendingSales:   data.Pending_Sales_Best_Record_Month__c,
                            sales:          data.Sales_Best_Record_Month__c
                        },
                        allTime: {
                            leads:          data.Total_Leads__c,
                            pendingSales:   data.Total_Pending_Sales__c,
                            sales:          data.Total_Sold_Deals__c
                        }
                    }
                });

            })
            .catch(err => console.log('(GET) Error in Repstats: \n', err));

        axios.post(
            '/sf/contact/findNo',
            this.postRequestQuarterSales,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                // descending sort -- highest sales first and null at the end:
                const salesRepsQuarterSales = res.data.records
                    .sort((a, b) => {
                        // the `Total_Sold_Deals_This_Quarter__c` property can have either numbers of null, so we convert NaN to a negative number:
                        const _a = isNaN(a.Total_Sold_Deals_This_Quarter__c) ? -1 : a.Total_Sold_Deals_This_Quarter__c;
                        const _b = isNaN(b.Total_Sold_Deals_This_Quarter__c) ? -1 : b.Total_Sold_Deals_This_Quarter__c;

                        return  _b - _a;
                    })

                // find sale rep rank:
                const salesRep = {...this.state.salesRep};
                // recall that array's are zero-indexed; hence the reason for `+1`:
                salesRep.rank = salesRepsQuarterSales.findIndex(item => item.Id === this.repId) + 1;

                this.setState({
                    salesRepsQuarterSales,
                    salesRep
                });
            })
            .catch(err => console.log('(POST) Error in Repstats: \n', err));

        axios.post('/sf/repsaletracker/findNo',
            {
                cancelToken: this.source.token
            })
            .then((res) => {

            })
            .catch(err => console.log('(POST) Error in Repstats: \n', err));
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    // ---------- methods: ----------
    /**
     * @method
     * @methodOf Repstats
     *
     * When "show stats" button is clicked, flip the card.
     */
    btnShowStatsOnClick = () => {
        this.setState({
            isFlipped: !this.state.isFlipped
        });
    };

    /**
     * @method
     * @methodOf Repstats
     *
     * Handler for when user selects a dropdown option -- redirects the user (using React Router) to the rep stats page based on the rep id.
     *
     * @param rep {object}: A single rep object from the `salesRep` array we set to state. We extract the Id from this object to form the query parameter.
     */
    searchRepOnSelect = (rep) => {
        const repId = rep.Id;
        this.props.history.push(`/repStats/${repId}`);
        window.location.reload();
    };

    render() {
        return (
            <div className="Repstats">
                <SectionHeading heading="Rep Scorecard" />

                {/* ---------- search rep filter: ---------- */}
                <div className="mb-5">
                    <SearchList
                        onSearchListSelect={(selectedRep) => this.searchRepOnSelect(selectedRep)}
                        placeholder="Search Reps"
                        dropDownList={this.state.salesRepsQuarterSales}
                        filterBy={["Name", "Id"]}
                        displayedProperty="Name"
                    />
                </div>

                {/* ---------- rep card: ---------- */}
                <div className={css.RepCard}>
                    <div className={this.state.isFlipped ? `${css.RepCard__Inner} ${css.Flip}` : css.RepCard__Inner}>

                        {/* ----- card front: ----- */}
                        <div className={css.RepCard__Front}>
                            <div className={css.RepCard__Front__Rank}>
                                <span className={css.RepCard__Front__RankNumber}>
                                    { (this.state.salesRep.rank && this.state.salesRep.salesThisQuarter) ? `#${this.state.salesRep.rank}` : 'N/A' }
                                </span>
                                <img src="/assets/sales_rep_card/badge_rank.png" alt=" "/>
                            </div>

                            {/* <img className={css.RepCard__Front__CardPhoto}
                                 src={`/images/${this.state.salesRep.name}.jpg`}
                                 onError={(event) => setFallbackAvatar(event)}
                                 alt="Sales Rep"
                            /> */}

                            <img className={css.RepCard__Front__CardPhoto}
                                src={`https://v3-portal-file-storage.s3.us-west-2.amazonaws.com/repPhotos/${this.state.salesRep.name}.jpg`} 
                                alt='Sales Rep Portrait' 
                                onError={(event) => setFallbackAvatar(event)} />

                            <div className={css.RepCard__Front__Badges}>
                                <img src="/assets/sales_rep_card/badge_solo_deal.png" alt=""/>
                                <img src="/assets/sales_rep_card/badge_locked_01.png" alt=""/>
                                <img src="/assets/sales_rep_card/badge_locked_02.png" alt=""/>
                                <img src="/assets/sales_rep_card/badge_locked_03.png" alt=""/>
                                <img src="/assets/sales_rep_card/badge_locked_04.png" alt=""/>
                                <img src="/assets/sales_rep_card/badge_locked_05.png" alt=""/>
                            </div>

                            <div className={css.RepCard__Front__Name}>
                                {this.state.salesRep.name}
                            </div>

                            <div className="d-flex justify-content-between w-100 mt-2">
                                <img
                                    className={css.RepCard__Front__TeamLogo} src={`/assets/teams/${this.state.salesRep.accountName}.png`}
                                    onError={(event) => event.target.src = '/assets/teams/team_not_found.png' }
                                    alt=" "
                                />

                                <div className="pl-3 flex-grow-1">
                                    <div className={css.RepCard__Front__jobTitle}>{this.state.salesRep.jobTitle}</div>
                                    <div>{this.state.salesRep.accountName}</div>
                                    <div className="text-sm">{this.state.salesRep.startDate}</div>
                                </div>
                            </div>
                        </div> {/* /.RepCard__Front */}

                        {/* ---------- card back: ---------- */}
                        <div className={css.RepCard__Back}>
                            <h2 className="mt-n2">{this.state.salesRep.name}</h2>
                            <div className="d-flex w-100 justify-content-between">
                                <div className={css.RepCard__Back__Badge}>
                                    <h4 className="py-2">
                                        { (this.state.salesRep.rank && this.state.salesRep.salesThisQuarter) ? `#${this.state.salesRep.rank}` : 'N/A' }
                                    </h4>
                                    <div className="pb-2">QUARTERLY RANK</div>
                                    <div className={css.RepCard__Back__Badge__Triangle}></div>
                                </div>
                                <div className={css.RepCard__Back__Badge}>
                                    <h4 className="py-2">{this.state.salesRep.conversionRate}%</h4>
                                    <div className="pb-2">ALL-TIME CONVERSION RATE</div>
                                    <div className={css.RepCard__Back__Badge__Triangle}></div>
                                </div>
                            </div>


                            <div className={css.RepCard__Back__TableHeader}>
                                All-TIME BEST
                            </div>

                            {/* ---------- 'all-time best' table: ---------- */}
                            <table>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Leads</th>
                                        <th>Pending Sales</th>
                                        <th>Sales</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Day</td>
                                        <td>{this.state.best.day.leads}</td>
                                        <td>{this.state.best.day.pendingSales}</td>
                                        <td>{this.state.best.day.sales}</td>
                                    </tr>
                                    <tr>
                                        <td>Week</td>
                                        <td>{this.state.best.week.leads}</td>
                                        <td>{this.state.best.week.pendingSales}</td>
                                        <td>{this.state.best.week.sales}</td>
                                    </tr>
                                    <tr>
                                        <td>Month</td>
                                        <td>{this.state.best.month.leads}</td>
                                        <td>{this.state.best.month.pendingSales}</td>
                                        <td>{this.state.best.month.sales}</td>
                                    </tr>
                                    <tr>
                                        <td>All-Time</td>
                                        <td>{this.state.best.allTime.leads}</td>
                                        <td>{this.state.best.allTime.pendingSales}</td>
                                        <td>{this.state.best.allTime.sales}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className={css.RepCard__Back__V3Logo}>
                                <img src="/assets/v3_logo_blue.png" alt="V3" />
                            </div>
                        </div>
                    </div>
                </div> {/* /.RepCard */}

                {/* Disabling for now because the rep stats need to be fixed */} 
                <div className="text-center mt-3">
                    <button className="btn btn-primary" type="button" onClick={() => this.btnShowStatsOnClick()}>More Stats</button>
                </div>
            </div>
        );
    }
};

export default withRouter(Repstats);
